<template>
  <div>
    <button v-if="!showForm" @click="showForm = true" class="hover:bg-gray-200 p-2 rounded-lg">Add List</button>
    <form v-if="showForm" @submit.prevent="handleSubmit" class="p-3 rounded-lg bg-white">
      <h4>Add a New Checklist</h4>
      <input type="text" placeholder="Checklist title " required v-model="title" class="dash italic" />
      <textarea type="text" placeholder="desc" required v-model="detail" class="dash italic"></textarea>
      <button class="hover:bg-gray-200 rounded-lg p-2">Add</button>
    </form>
  </div>
</template>

<script>
import { ref } from "vue"
import useDocument from "@/composables/useDocument"
export default {
  props: ["todolist"],
  setup(props) {
    const title = ref("")
    const detail = ref("")
    const showForm = ref(false)
    const { updateDoc } = useDocument("todolists", props.todolist.id)

    const handleSubmit = async () => {
      const newChecklist = {
        title: title.value,
        detail: detail.value,
        id: Math.floor(Math.random() * 1000000),
      }
      await updateDoc({
        checklists: [...props.todolist.checklists, newChecklist],
      })
      title.value = ""
      detail.value = ""
    }
    return { title, detail, showForm, handleSubmit }
  },
}
</script>

<style scoped></style>
